import React from 'react';
import { useHistory } from 'react-router-dom';
import './styles.scss';
import BreadcrumbUI, { ItemType } from 'components/Breadcrumb/UI';

interface Props {
  titles: Array<string>;
}

const CampaignsBreadcrumbs: React.FC<Props> = ({ titles }) => {
  const history = useHistory();

  const getBreadcrumbItems = (): Array<ItemType> => {
    const items: Array<ItemType> = [];
    if (titles.length > 1) {
      titles.forEach((elem, i, arr) => {
        let stepSize = i - arr.length + 1;
        const item: ItemType = { label: elem, onClick: undefined };
        if (stepSize < 0) {
          item.onClick = () => history.go(stepSize);
        }
        items.push(item);
      });
    } else {
      const item: ItemType = { label: titles[0] };
      items.push(item);
    }
    return items;
  };

  return <BreadcrumbUI items={getBreadcrumbItems()} />;
};

export default CampaignsBreadcrumbs;
